import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "hooks/auth";
import ProtectedRoute from "./ProtectedRoute";

interface StudentRouteProps {
  children: React.ReactNode;
}

const StudentRoute: React.FC<StudentRouteProps> = ({ children }) => {
  const { role } = useAuth();

  return (
    <ProtectedRoute>
      {role === "student" ? (
        children
      ) : (
        <Navigate to="/not-found" replace />
      )}
    </ProtectedRoute>
  );
};

export default StudentRoute;
